import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import clusterService from "./clusterService";

export const getClusters = createAsyncThunk(
  "cluster/get-cluster",
  async (thunkAPI) => {
    try {
      return await clusterService.getClusters();
      
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const resetState = createAction("Reset_all");

const initialState = {
  cluster: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const clusterSlice = createSlice({
  name: "cluster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClusters.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getClusters.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.cluster = action.payload;
      })
      .addCase(getClusters.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })


      .addCase(resetState, () => initialState);
  },
});

export default clusterSlice.reducer;
